// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDBHzKF5R_QYbhWuo8qCOhqWPDrPe8NIl0",
  authDomain: "hcvudla.firebaseapp.com",
  projectId: "hcvudla",
  storageBucket: "hcvudla.firebasestorage.app",
  messagingSenderId: "97527143667",
  appId: "1:97527143667:web:1c3ec4092d8d0de6c2eb86",
  measurementId: "G-46255K39G1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;
